<template>
    <div id="bodyOuter">
    
    <keep-alive>
        <div class="funcKeys-container">
            <div class="part1">
                <func-keys v-for="(funcKey,index) in funcKeys1" 
                :key="'funcKey'+index" 
                @click.native='funckeyPress(funcKey)'
                ref="funcKeys1" 
                :class="{'btnAct': funcKey==currentKey}">
                    <template v-slot:funcName>
                        <ul>
                            <li>{{funcKey}}</li>
                        </ul>
                    </template>
                </func-keys> 
            </div> 


            <div class="part2">
                <func-keys
                @click.native="funckeyPress('EXEC')"
                ref="funcKeys2" 
                :class="{'btnAct': currentKey == 'EXEC'}">
                    <template v-slot:funcName>
                        <div>
                            <p>EXEC</p>
                        </div>
                    </template>
                </func-keys> 
            </div> 

            <div class="part3">
                <func-keys
                v-for="(funcKey,index) in funcKeys2" 
                :key="'funcKey'+index" 
                @click.native="funckeyPress(funcKey)"
                ref="funcKeys3" 
                :class="{'btnAct': funcKey==currentKey}">
                    <template v-slot:funcName>
                        <ul>
                            <li>{{funcKey}}</li>
                        </ul>
                    </template>
                </func-keys> 
            </div> 
    
        </div>
    </keep-alive>

    <keep-alive>
        <div class="numKeys-container" >
                <num-keys v-for="numKey in numKeys" 
                :key="numKey" 
                @click.native="keyPress(numKey)"
                :class="{'btnAct': numKey==currentKey}">
                    <template v-slot:numName>
                        <p>{{numKey}}</p>
                    </template> 
                </num-keys>
        </div>
    </keep-alive>   
        
    <keep-alive>
        <div class="alphaKeys-container">
            <alpha-keys v-for="alphaKey in alphaKeys" 
            :key="alphaKey" 
            @click.native="keyPress(alphaKey)" 
            :class="{'btnAct': alphaKey==currentKey}">
                <template v-slot:alphaName>
                    <p>{{alphaKey}}</p>
                </template> 
            </alpha-keys>
        </div>
    </keep-alive>
        
    </div>
</template>

<script>

import FuncKeys from 'views/cdu/cduBody/FuncKeys'
import NumKeys from 'views/cdu/cduBody/NumKeys'
import AlphaKeys from 'views/cdu/cduBody/AlphaKeys'

import {
    CHGMEMODATA
} from 'store/m-types'

export default { 
    name: 'BodyOuter',
    components: {
        FuncKeys,
        NumKeys,
        AlphaKeys
    },
    data() {
        return {
            funcKeys1: ['INIT\nREF', 'RTE', 'CLB', 'CRZ', 'DES', 'MENU', 'LEGS', 'DEP\nARR', 'HOLD', 'PROG'],
            funcKeys2: ['N1\nLIMIT', 'FIX', 'PREV\nPAGE', 'NEXT\nPAGE'],
            numKeys: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '.', '0', '+/-'],
            alphaKeys: ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z','SP','DEL','/','CLR'],
            currentKey: null,
            addKey: {
                letter: '+',
                isSub: false
            }
        }
    },
    methods: {
        funckeyPress(e){
            this.$emit('funckeyPress', e)
            this.currentKey = e
            setTimeout(()=>{
                this.currentKey = null
            }, 100)
        },

        keyPress(e){
            this.currentKey = e
            setTimeout(()=>{
                this.currentKey = null
            }, 100)

            let memoData = this.$store.state.currentStatus.memoData
            
            if(e === 'CLR'){
                if(memoData.input){
                    if(memoData.input === 'DELETE'){
                        memoData.input = ''
                    }
                    memoData.input = memoData.input.substring(0, memoData.input.length - 1)

                    
                }else if(memoData.warning.length){
                    memoData.warning.shift()
                    

                }else if(memoData.caution.length){
                    memoData.caution.shift()
                    
                }

            }else if(e === 'DEL'){

                memoData.input = 'DELETE'
            }else if(e === 'SP'){
                if(!(memoData.input === 'DELETE')){
                    memoData.input = memoData.input + '\xa0'
                }
            }else if(e === '+/-'){
                if(!(memoData.input === 'DELETE')){

                    if((memoData.input.charAt(memoData.input.length - 1) === '+') && (this.addKey.isSub)){
                        memoData.input = memoData.input.substring(0, memoData.input.length - 1)
                    }
                    memoData.input = memoData.input + this.addKey.letter

                    this.addKey.letter = '-'
                    this.addKey.isSub = true

                    setTimeout(()=>{
                        this.addKey.letter = '+'
                        this.addKey.isSub = false
                    },500)
                }
            }else{
                memoData.input = memoData.input + e
            }

            this.$store.commit(CHGMEMODATA, memoData)
        }
    },

}
</script>

<style scoped>
    #bodyOuter{
        height: 7.4rem;
        width: 9.386667rem;
        position: absolute;
        bottom: 0;
        margin: 0 .12rem 0;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
    }
    .funcKeys-container{
        width: 7.826667rem;
        height: 3.626667rem;
        background-color: var(--color-funcKeys-bgc);
        border-radius: .16rem;
        border: 1px solid #1c1d1d;
        box-shadow: 1px 1px 1px #202021;
        line-height: .2rem;
        padding: .2rem;
        display: flex;
        flex-wrap: wrap;
    }

    .funcKeys-container > .part1{
        width: 5.84rem;
        height: 1.493333rem;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-content: space-between;
    } 

    .funcKeys-container > .part2{
        align-self: flex-end;
        margin: 0 0 .04rem .4rem;
    }

    .funcKeys-container > .part2::before{
        content: "";
        display: inline-block;
        align-self: flex-end;
        width: .733333rem;
        height: .186667rem;
        border-radius: .16rem;
        margin-bottom: .08rem;
        background-color: #003333;
        /* background-color: greenyellow; */
        border: 1px solid #003c2c;
    }

    .funcKeys-container > .part3{
        width: 2.28rem;
        height: 1.6rem;
        padding-top: .106667rem;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-content: space-between;
    }
    
    
    .numKeys-container{
        height: 3.4rem;
        width: 2.68rem;
        position: absolute;
        left: .68rem;
        bottom: .44rem;
        display: inline-flex;
        flex-wrap: wrap;
        justify-content: space-between;
        padding: .2rem;

    }

    .alphaKeys-container{
        width: 5.2rem;
        height: 5rem;
        position: absolute;
        right: .76rem;
        bottom: 0.44rem;
        border-radius: 0.16rem 0;
        padding: .2rem 0.15rem;
        box-shadow: -2px -1px 2px #212222;
        background-color: var(--color-frame-bgc);
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
    }

    .alphaKeys-container>.alphaKeys:nth-last-child(-n+4){
        font-size: .25rem;
    }

    .alphaKeys-container>.alphaKeys:nth-last-child(2){
        font-size: .4rem;
        font-weight: bold;
    }

</style>